import React, { useState } from 'react';

const TDSReturnFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with TDS Return Filing.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with  TDS Return Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              TDS Return Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive Tax Deducted at Source (TDS) return filing services for businesses and deductors. We ensure accurate TDS calculation, timely quarterly filings, and complete compliance with Income Tax regulations to avoid penalties and interest.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🛡️</span> Ensure TDS Compliance
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of TDS Return Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Tax Deducted at Source (TDS) is a mechanism where the deductor (payer) deducts tax at specified rates from payments like salary, interest, professional fees, rent, etc., and deposits it with the government. Quarterly TDS return filing is mandatory for all deductors.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive TDS return filing service covers all quarterly returns (Form 24Q, 26Q, 27Q, 27EQ) with accurate TDS calculation, challan reconciliation, and timely filing to ensure complete compliance with Income Tax regulations.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With expert handling of TDS provisions, rates, and due dates, we make your TDS compliance hassle-free while ensuring accurate Form 16/16A issuance to deductees.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Complete Compliance:</strong> Ensure 100% compliance with all TDS provisions and avoid penalties under Section 234E.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Quarterly Filing:</strong> All TDS returns filed before due dates (July 31st, Oct 31st, Jan 31st, May 31st) to avoid late fees.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Accurate TDS Calculation:</strong> Expert calculation of TDS under correct sections (192, 194, 194A, 194C, etc.) with proper rates.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Challan Reconciliation:</strong> Complete reconciliation of TDS payments with challan details to avoid mismatches.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Form 16/16A Generation:</strong> Accurate preparation and issuance of Form 16 for employees and Form 16A for other deductees.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">TAN Compliance:</strong> Proper TAN (Tax Deduction and Collection Account Number) usage and compliance.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Notice Handling:</strong> Expert assistance in responding to TDS notices, demand notices, and intimation u/s 200A.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with TDS Return Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for TDS Return Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📁", title: "Data Collection", desc: "Collect payment details, PAN of deductees, TDS rates, and challan information for the quarter." },
              { number: "02", icon: "🧮", title: "TDS Calculation", desc: "Calculate TDS amounts under correct sections (194C, 194J, 194I, etc.) with applicable rates." },
              { number: "03", icon: "💳", title: "Challan Reconciliation", desc: "Reconcile TDS payments with challan details (BSR code, date, serial number) for accuracy." },
              { number: "04", icon: "📝", title: "Return Form Preparation", desc: "Prepare appropriate TDS return form (24Q, 26Q, 27Q, 27EQ) with deductee and challan details." },
              { number: "05", icon: "🔍", title: "Data Validation", desc: "Validate PAN details, challan information, and TDS calculations to ensure accuracy." },
              { number: "06", icon: "📤", title: "Online Return Filing", desc: "File TDS return through TIN-NSDL portal with digital signature or using TAN-based login." },
              { number: "07", icon: "✅", title: "Form 16/16A Generation", desc: "Generate and issue Form 16 for employees and Form 16A for other deductees after filing." },
              { number: "08", icon: "🏆", title: "Filing Acknowledgement", desc: "Provide filing acknowledgement (Form 27A) and track return processing until acceptance." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for TDS Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential Documents for Quarterly Compliance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "TAN Certificate", desc: "Tax Deduction and Collection Account Number certificate for the deductor." },
              { icon: "👥", title: "Deductee PAN Details", desc: "PAN numbers of all deductees (employees, vendors, professionals, etc.)." },
              { icon: "💰", title: "Payment Details", desc: "Details of payments made with amounts, dates, and TDS applicable sections." },
              { icon: "💳", title: "TDS Challan Details", desc: "Challan details (BSR code, date, serial no.) for TDS payments made to bank." },
              { icon: "📄", title: "Salary Register", desc: "Quarterly salary register for employees (for Form 24Q preparation)." },
              { icon: "📋", title: "Vendor Payments", desc: "Details of payments to contractors, professionals, and other vendors." },
              { icon: "🏠", title: "Rent Payment Details", desc: "Rent payment details if TDS deducted under Section 194I." },
              { icon: "💵", title: "Interest Payments", desc: "Interest payment details if TDS deducted under Section 194A." },
              { icon: "✅", title: "Previous Returns", desc: "Copy of last quarter's TDS return for reference and continuity." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "✅", title: "Filed TDS Return Acknowledgement", desc: "Form 27A acknowledgement and filing confirmation from TIN-NSDL portal for each quarter." },
              { icon: "📄", title: "Form 16/16A Generation", desc: "Accurate Form 16 for employees and Form 16A for other deductees with TDS details." },
              { icon: "📊", title: "TDS Computation Report", desc: "Detailed TDS computation report showing calculations under various sections and rates." },
              { icon: "📅", title: "Compliance Calendar", desc: "Quarterly TDS compliance calendar with all filing and payment due dates." },
              { icon: "🎧", title: "Ongoing TDS Support", desc: "Quarterly reminder services, TDS notice handling, challan reconciliation support, rate change updates" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      TDS Return Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What are the due dates for TDS return filing?", 
                    answer: "Q1 (Apr-Jun): July 31st, Q2 (Jul-Sep): Oct 31st, Q3 (Oct-Dec): Jan 31st, Q4 (Jan-Mar): May 31st of the following year." 
                  },
                  { 
                    question: "What is the penalty for late filing of TDS returns?", 
                    answer: "Late filing fee of ₹200 per day under Section 234E until the return is filed, plus penalties under Section 271H up to ₹25,000." 
                  },
                  { 
                    question: "What are the different TDS return forms?", 
                    answer: "Form 24Q (Salaries), Form 26Q (Non-salaries), Form 27Q (NRIs), Form 27EQ (TCS). Each form has specific requirements." 
                  },
                  { 
                    question: "When is TAN required for TDS filing?", 
                    answer: "TAN is mandatory for all entities deducting TDS. It must be quoted in all TDS returns, challans, and certificates." 
                  },
                  { 
                    question: "Can we revise TDS returns after filing?", 
                    answer: "Yes, TDS returns can be revised for correction of errors. There's no limit on the number of revisions within the time limit." 
                  },
                  { 
                    question: "What is the due date for TDS payment?", 
                    answer: "TDS must be deposited by the 7th of the following month (except for March, which is April 30th). For government deductors, same day without challan." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for TDS Compliance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of TDS experts handle your quarterly compliance and ensure accurate Form 16/16A issuance.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our TDS Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default TDSReturnFiling;